var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"textRef",class:`split-parent overflow-hidden whitespace-normal ${_vm.className}`,style:({
    textAlign: _vm.textAlign,
    wordWrap: 'break-word'
  })},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }